import { 
    GAME_FACT_RUGBY_STOP,
    GAME_FACT_ESSAI,
    GAME_FACT_RUGBY_STAR,
    GAME_FACT_TRANSFORMATION,
    GAME_FACT_DROP,
    GAME_FACT_PENALITE,
    GAME_FACT_SHOOTOUTPENALTY,
    GAME_FACT_YELLOWCARD,
    GAME_FACT_REDCARD,
    GAME_FACT_FAULT,
    GAME_FACT_REPLACEMENT,
    GAME_FACT_COMMENT,
    GAME_FACT_ORANGECARD
} from '../../constants.js'
import { CommentDto } from '../../gamefacts/rugby/CommentDto.js.js'
import { DropDto } from '../../gamefacts/rugby/DropDto.js'
import { EssaiDto } from '../../gamefacts/rugby/EssaiDto.js'
import { FaultDto } from '../../gamefacts/rugby/FaultDto.js'
import { OrangeCardDto } from '../../gamefacts/rugby/OrangeCardDto.js'
import { PenaliteDto } from '../../gamefacts/rugby/PenaliteDto.js'
import { RedCardDto } from '../../gamefacts/rugby/RedCardDto.js'
import { ReplacementDto } from '../../gamefacts/rugby/ReplacementDto.js'
import { ShootoutPenaltyDto } from '../../gamefacts/rugby/ShootoutPenaltyDto.js'
import { StarDto } from '../../gamefacts/rugby/StarDto.js'
import { StopDto } from '../../gamefacts/rugby/StopDto.js'
import { TransformationDto } from '../../gamefacts/rugby/TransformationDto.js'
import { YellowCardDto } from '../../gamefacts/rugby/YellowCardDto.js'

export const rugbyResolvers = {
    [GAME_FACT_RUGBY_STOP]: (event) => new StopDto(event),
    [GAME_FACT_ESSAI]: (event) => new EssaiDto(event),
    [GAME_FACT_RUGBY_STAR]: (event) => new StarDto(event),
    [GAME_FACT_TRANSFORMATION]: (event) => new TransformationDto(event),
    [GAME_FACT_DROP]: (event) => new DropDto(event),
    [GAME_FACT_PENALITE]: (event) => new PenaliteDto(event),
    [GAME_FACT_SHOOTOUTPENALTY]: (event) => new ShootoutPenaltyDto(event),
    [GAME_FACT_YELLOWCARD]: (event) => new YellowCardDto(event),
    [GAME_FACT_ORANGECARD]: (event) => new OrangeCardDto(event),
    [GAME_FACT_REDCARD]: (event) => new RedCardDto(event),
    [GAME_FACT_FAULT]: (event) => new FaultDto(event),
    [GAME_FACT_REPLACEMENT]: (event) => new ReplacementDto(event),
    [GAME_FACT_COMMENT]: (event) => new CommentDto(event),
}